import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mandMobile from 'mand-mobile'
// 引入样式
import 'mand-mobile/lib/mand-mobile.css'
import './assets/styles/reset.css'
import './assets/styles/public.css'
import './assets/styles/border.css'
// 测试
// import {
//   FromDates,
// } from './api/cs'

// Vue.prototype.$fromdate = FromDates

// 引入dayjs
import dayjs from 'dayjs'
Vue.prototype.dayjs = dayjs// 可以全局使用dayjs

// 自适应
import 'lib-flexible/flexible'
// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// vant
import Vant from 'vant';
import 'vant/lib/index.css';
// qs
import qs from 'qs'
// import ElementUI from 'element-ui';
Vue.prototype.$qs = qs;
// 修改 el-dialog 默认点击遮照为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false

// 打印
import Print from 'vue-print-nb'

Vue.config.productionTip = false
// 日期格式化
import {
  timeFormat,
  Timecl
} from './api/timeFormat'

Vue.directive('focus', {
  inserted: function (el) {
    el.querySelector('input').focus();
  }
});

Vue.prototype.$timeFormat = timeFormat;
Vue.prototype.$Timecl = Timecl;

Vue.use(Print)
Vue.use(ElementUI)
Vue.use(Vant);
Vue.use(mandMobile)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')